var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "82px",
    height: "82px",
    viewBox: "0 0 82 82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "round_zen_yellow") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-2021",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "round_zen_yellow",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-4",
    stroke: "#000000",
    strokeWidth: 2,
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "zen/zen_dark"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.390244, 24.390244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3170732,25.3658537 L3.90243902,25.3658537 C3.36292683,25.3658537 2.92682927,25.8019512 2.92682927,26.3414634 C2.92682927,26.8809756 3.36292683,27.3170732 3.90243902,27.3170732 L27.3170732,27.3170732 C27.8565854,27.3170732 28.2926829,26.8809756 28.2926829,26.3414634 C28.2926829,25.8019512 27.8565854,25.3658537 27.3170732,25.3658537 L27.3170732,25.3658537 Z M30.2439024,21.4634146 L0.975609756,21.4634146 C0.436097561,21.4634146 0,21.8995122 0,22.4390244 C0,22.9785366 0.436097561,23.4146341 0.975609756,23.4146341 L30.2439024,23.4146341 C30.7834146,23.4146341 31.2195122,22.9785366 31.2195122,22.4390244 C31.2195122,21.8995122 30.7834146,21.4634146 30.2439024,21.4634146 L30.2439024,21.4634146 Z M20.4878049,29.2682927 L10.7317073,29.2682927 C10.1921951,29.2682927 9.75609756,29.7043902 9.75609756,30.2439024 C9.75609756,30.7834146 10.1921951,31.2195122 10.7317073,31.2195122 L15.6058537,31.2195122 L15.6097561,31.2195122 L15.6136585,31.2195122 L20.4878049,31.2195122 C21.0273171,31.2195122 21.4634146,30.7834146 21.4634146,30.2439024 C21.4634146,29.7043902 21.0273171,29.2682927 20.4878049,29.2682927 L20.4878049,29.2682927 Z M2.52487805,19.5121951 C2.15609756,18.2741463 1.95121951,16.9668293 1.95121951,15.6097561 C1.95121951,8.06731707 8.06634146,1.95121951 15.6097561,1.95121951 C23.1531707,1.95121951 29.2682927,8.06731707 29.2682927,15.6097561 C29.2682927,16.9668293 29.0634146,18.2741463 28.6946341,19.5121951 L30.7082927,19.5121951 C31.0302439,18.2634146 31.2195122,16.96 31.2195122,15.6097561 C31.2195122,6.98926829 24.2312195,0 15.6097561,0 C6.98829268,0 0,6.98926829 0,15.6097561 C0,16.96 0.189268293,18.2634146 0.511219512,19.5121951 L2.52487805,19.5121951 L2.52487805,19.5121951 Z",
    id: "Icon_Tranquille",
    fill: "#1F2532",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSol);
export default __webpack_public_path__ + "static/media/sol.b2d02c5ee2ee9232f305375b7181b54c.svg";
export { ForwardRef as ReactComponent };